










import {Vue, Component} from 'vue-property-decorator';

@Component({
  name: 'EmptyCatalog',
  props: ['text'],
})
export default class EmptyCatalog extends Vue {}
